/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SiteNav_viewer = {
    readonly navigation?: {
        readonly modules: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SiteNavItem_navigationModule">;
        } | null> | null;
    } | null;
    readonly tradeNavigation?: {
        readonly modules: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SiteNavItem_navigationModule">;
        } | null> | null;
    } | null;
    readonly " $refType": "SiteNav_viewer";
};
export type SiteNav_viewer$data = SiteNav_viewer;
export type SiteNav_viewer$key = {
    readonly " $data"?: SiteNav_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SiteNav_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "rootId",
  "variableName": "previewKey"
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NavigationModule",
    "kind": "LinkedField",
    "name": "modules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceId",
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SiteNavItem_navigationModule"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchNav"
    },
    {
      "kind": "RootArgument",
      "name": "fetchTradeNav"
    },
    {
      "kind": "RootArgument",
      "name": "previewKey"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNav_viewer",
  "selections": [
    {
      "condition": "fetchNav",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "Navigation",
          "kind": "LinkedField",
          "name": "navigation",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchTradeNav",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "tradeNavigation",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "userType",
              "value": "TRADE"
            }
          ],
          "concreteType": "Navigation",
          "kind": "LinkedField",
          "name": "navigation",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = '67f862a1d5c0841169217f3a351d0070';
export default node;
